import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'page-configuration-logs',
  templateUrl: 'configuration-logs.html'
})

export class ConfigurationLogsPage {

  list: any;
  load_logs: boolean = false;
  //datatable
  sorts = [
    { prop: 'date', dir: 'asc' },
    { prop: 'category', dir: 'asc' },
    { prop: 'page', dir: 'asc' },
    { prop: 'user', dir: 'asc' },
    { prop: 'rol', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public translate: TranslateService) {

    if (this.globals.checkLimitsByLicense('logs', 'movements_list')) {
      this.getList200LogMovements();
    }
  }

  update() {
    this.logs_array_tmp = [];
    this.list_logs_array = [];
    this.logs_array_filtered = [];
    this.getList200LogMovements();
  }

  logs_array_tmp: any = [];
  logs_array_filtered: any = [];
  list_logs_array: any = [];
  logs_searchbar_text: string = '';
  async getList200LogMovements() {
    this.load_logs = false;
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid);

    await this.http.post(this.globals.analytics_path + 'log/get200', body, { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }) }).subscribe(async data => {
      this.logs_array_tmp = data;
      if (this.logs_array_tmp.length != 0) {
        this.getListlogs();
      } else {
        this.list_logs_array = [];
        this.logs_array_filtered = [];
        this.load_logs = true;
      }
    });

  }

  getListlogs() {
    this.load_logs = true;
    this.list_logs_array = this.logs_array_tmp;
    this.logs_array_filtered = this.logs_array_tmp;
    this.logsSearch(this.logs_searchbar_text);
  }

  logsSearch(value) {
    if (value) {
      this.logs_array_filtered = this.list_logs_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.logs_array_filtered = this.list_logs_array;
    }
  }

  onSort(event) {
    var logs_array = this.logs_array_filtered;
    switch (event.column.name) {
      case 'date':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.date.toLowerCase().localeCompare(b.date.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.date.toLowerCase().localeCompare(a.date.toLowerCase()));
        }
        break;
      case 'category':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.category.toLowerCase().localeCompare(b.category.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.category.toLowerCase().localeCompare(a.category.toLowerCase()));
        }
        break;
      case 'page':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.page.toLowerCase().localeCompare(b.page.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.page.toLowerCase().localeCompare(a.page.toLowerCase()));
        }
        break;
      case 'user':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.user.toLowerCase().localeCompare(b.user.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.user.toLowerCase().localeCompare(a.user.toLowerCase()));
        }
        break;
      case 'rol':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.rol.toLowerCase().localeCompare(b.rol.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.rol.toLowerCase().localeCompare(a.rol.toLowerCase()));
        }
        break;
    }
    this.logs_array_filtered = logs_array;
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-logs/configuration-logs.ts